import {get, post} from '../index'
export default {
  // 文章分类列表
  getdrainageClassifyList (querys) {
    return get('/drainage/admin/adminDrainageClassify/listAll', querys)
  },// 添加文章分类
  addDrainageClassifyInfo (querys) {
    return post('/drainage/admin/adminDrainageClassify/createOne', querys)
  }, // 编辑文章分类
  editDrainageClassifyInfo (querys) {
    return post('/drainage/admin/adminDrainageClassify/updateOne', querys)
  },
  changeDelDrainageClassifyInfo (querys) {
    return post('/drainage/admin/adminDrainageClassify/changeDel', querys)
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/drainage.js